import { useMutation } from "@apollo/client";
import {
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import background from "assets/images/login_photo.png";
import papsImg from "assets/images/logo-bleu.svg";
import papsChristmasLogo from "assets/images/Paps_Noel.svg";
import { Button } from "ui/Button";
import useText from "constants/text";
import { ValidateAccountClient, VerifyEmailClient } from "domains/Users/graphql/mutations";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "styled-components/macro";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0),
      height: "100%",
      width: "100%",
      background: "#fff",
      display: "flex",
      justifyContent: "center",
    },
    papsers: {
      width: "40%",
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "@media(max-width: 616px)": {
        visibility: "hidden",
      },
    },
    login: {
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    container: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      flexDirection: "column",
    },
    group: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "4%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    imgDiv: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    title: {
      paddingTop: "10%",
      marginLeft: "auto",
      marginRight: "auto",
      color: theme.palette.primary.main,
      padding: theme.spacing(2),
      fontWeight: 900,
      fontSize: 42,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      "& .MuiTextField-root, .MuiFormControl-root ": {
        margin: theme.spacing(1),
        width: "45ch",
        backgroundColor: "#f2f2f2",
        borderRaduis: 4.7,
      },
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: "10%",
    },
    buttons: {
      width: "45ch",
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      justifyContent: "space-between",
      marginTop: 8,
    },
    log: {
      background: theme.palette.primary.main,
      width: "14ch",
      color: "#fff",
      fontSize: 16.8,
      marginLeft: "auto",
    },
    pwd: {
      color: theme.palette.primary.main,
    },
    socials: {
      width: "45ch",
      display: "flex",
      marginTop: 10,
      justifyContent: "space-between",
      marginLeft: "auto",
      marginRight: "auto",
    },
    social: {
      borderRadius: 4.2,
      border: "solid 0.9px rgba(0, 0, 0, 0.1)",
      width: "58ch",
      marginTop: 30,
      marginBottom: "auto",
      display: "flex",
      fontSize: 12,
      color: "#9c9292",
      padding: 10,
    },
    viewMessageContent: {
      display: "flex",
      flexDirection: "column",
      "& .MuiTextField-root, .MuiFormControl-root ": {
        margin: theme.spacing(1),
        width: "45ch",
        backgroundColor: "#f2f2f2",
        borderRaduis: 4.7,
      },
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: "10%",
    },
    viewmessage: {
      border: "solid 0.9px red",
      width: "58ch",
      marginBottom: 30,
      display: "flex",
      fontSize: 14,
      color: "red",
      padding: 10,
    },
    infosmessage: {
      width: "28ch",
      marginBottom: 30,
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      fontSize: 14,
      color: "#39aacd",
      padding: 10,
    },
    icon: {
      marginTop: "auto",
      marginBottom: "auto",
      padding: 5,
    },
    text: {
      marginTop: "auto",
      marginBottom: "auto",
    },
    email: {
      //   fontSize: 12,
      marginLeft: "auto",
      marginRight: "auto",
      color: "#c1bcbc",
    },
  })
);
const defaultLogger = {
  repeat_password: "",
  password: "",
};
export function Confirmation() {
  const styles = useStyles();
  const { search } = useLocation();
  const { text } = useText();
  const [logger, setLogger] = React.useState(defaultLogger);
  const [showPassword, setShowPassword] = React.useState(false);
  const [isFormSubmited] = React.useState(false);
  const [email, setEmail] = React.useState<string>("");
  const [activePage, setActivePage] = React.useState(false);
  const [verififyToken, { loading }] = useMutation(VerifyEmailClient);
  const [setpassword] = useMutation(ValidateAccountClient);
  const [token, setToken] = React.useState<string>("");
  const [message, setMessage] = React.useState(null);
  const navigator = useNavigate();
  const logo = process.env.REACT_APP_PAPS_GIFT === "true" ? papsChristmasLogo : papsImg;
  const onChanged = (event: any) => {
    event.persist();
    setLogger((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handlerAuthentification = async (event: any) => {
    event.preventDefault();
    if (
      logger.password.length > 0 &&
      logger.repeat_password.length > 0 &&
      logger.password.localeCompare(logger.repeat_password) === 0
    ) {
      setpassword({
        variables: {
          input: {
            token,
            password: logger.password,
          },
        },
      })
        .then((response) => {
          // todo
          const { message: msg, code } = response?.data.clientValidateAccount;
          if (code === 200) {
            navigator("/login");
          } else {
            setMessage(msg);
          }
        })
        .catch(() => {});
    } else {
      setMessage(text.confirmation_account.confirmation_account_error);
    }
  };
  const locationSearchMatches = new URLSearchParams(search);
  React.useEffect(() => {
    if (locationSearchMatches.has("token")) {
      const confirmToken = locationSearchMatches.get("token");
      verififyToken({
        variables: {
          input: {
            token: confirmToken,
          },
        },
      })
        .then((result) => {
          const {
            data: { clientVerifyAccount },
          } = result;

          if (clientVerifyAccount?.code === 200) {
            setActivePage(true);
            setEmail(clientVerifyAccount?.data?.account?.email);
            setToken(clientVerifyAccount?.data?.token);
          } else {
            setMessage(text.confirmation_account.confirmation_account_error);
          }
        })
        .catch(() => {
          setMessage(text.confirmation_account.confirmation_account_server_error);
        });
    } else {
      navigator("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className={styles.root}>
      <div className={styles.papsers} />
      <div className={styles.login}>
        <div className={styles.container}>
          <div className={styles.group}>
            <div className={styles.imgDiv}>
              <img
                src={logo}
                alt="paps icon"
                css={`
                  margin-left: auto;
                  margin-right: auto;
                `}
              />
            </div>
            <div className={styles.title}>Welcome</div>
          </div>
          {loading && (
            <div className={styles.viewMessageContent}>
              <div className={styles.infosmessage}>
                <CircularProgress />
                {text.confirmation_account.confirmation_account_verification}
              </div>
            </div>
          )}
          {activePage && !loading ? (
            <form className={styles.form} onSubmit={handlerAuthentification}>
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
              <div
                className={styles.viewmessage}
                style={{
                  visibility: message ? "visible" : "hidden",
                }}
              >
                {message}
              </div>
              <div className={styles.email}>{email}</div>
              <div
                style={{
                  margin: "auto",
                }}
              >
                <FormControl variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    {text.confirmation_account.confirmation_account_password}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    value={logger.password}
                    name="password"
                    onChange={onChanged}
                    error={isFormSubmited && logger?.password?.length === 0}
                    required
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={70}
                  />
                  {logger?.password?.length !== 0 && logger.password.length < 6 && (
                    <FormHelperText
                      id="my-helper-text"
                      style={{
                        color: "red",
                      }}
                    >
                      {text.confirmation_account.confirmation_account_password_error}
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
              <div
                style={{
                  margin: "auto",
                }}
              >
                <FormControl variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    {text.confirmation_account.confirmation_account_repeat_password}
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password-repeat"
                    type={showPassword ? "text" : "password"}
                    value={logger.repeat_password}
                    name="repeat_password"
                    onChange={onChanged}
                    error={isFormSubmited && logger?.repeat_password?.length === 0}
                    required
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={70}
                  />
                  {logger?.repeat_password?.length !== 0 && logger.repeat_password.length < 6 && (
                    <FormHelperText
                      id="my-helper-text"
                      style={{
                        color: "red",
                      }}
                    >
                      {text.confirmation_account.confirmation_account_password_error}
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
                <Grid xs={12} item >
                  <Button className={styles.log} type="submit">
                    {text.confirmation_account.confirmation_account_confirm}
                  </Button>
                  </Grid>
                </Grid>
            </form>
          ) : (
            <div className={styles.viewMessageContent}>
              <div
                className={styles.viewmessage}
                style={{
                  visibility: message ? "visible" : "hidden",
                }}
              >
                {message}
              </div>
              <Button
                style={{
                  visibility: message ? "visible" : "hidden",
                }}
                variant="outlined"
                color="primary"
                onClick={() => navigator("/login")}
              >
                {text.confirmation_account.confirmation_account_back_to_login}
              </Button>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}

export default Confirmation;
